const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJjIconStationeryRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "m14.008 3.522-2.161-2.146A1.27 1.27 0 0 0 10.943 1H5.44v2.419H1.617V15h8.943v-2.443h3.824V4.431a1.25 1.25 0 0 0-.376-.909m-3.819 2.424L8.028 3.8a1.27 1.27 0 0 0-.904-.376h-.682V2.002h4.042c.188 0 .335.147.335.335v2.22h2.23c.188 0 .335.147.335.335v6.661h-2.822V6.852c0-.344-.133-.666-.376-.909ZM6.996 4.757v2.22h2.23c.188 0 .335.147.335.335v6.687H2.619V4.421h4.042c.188 0 .335.147.335.335Z",
    style: {
      fill: "#eb1600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M3.667 13H6.5v-1H3.667z",
    style: {
      fill: "#eb1600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M3.667 8H7V9H3.667z",
    style: {
      fill: "#eb1600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M3.667 10H8.567V11H3.667z",
    style: {
      fill: "#eb1600"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJjIconStationeryRgb);
export default __webpack_public_path__ + "static/media/JJ_Icon_Stationery_RGB.5562e432ce70fb2cb64e7fa2c3f5b9d6.svg";
export { ForwardRef as ReactComponent };